module.exports = __webpack_public_path__ + "img/image-03.e444364b.jpg";